const SearchTermParams = ['k', 'soc', 'jt', 'j', 'a'];
const dataLayer = (<any>window)['dataLayer'];

export function log_event(item: string, event: string, ignoreLogAttribute: boolean, dataElement: HTMLElement, additionalUrlInfo: string | null = null) {
    if (ignoreLogAttribute || dataElement.getAttribute("data-ga-log")) {
        const ga = (<any>window).ga
        let path_name = window.location.pathname;
        if (additionalUrlInfo !== null) {
            path_name = path_name + additionalUrlInfo;
        }
        let label = "USAJOBS_" + path_name + window.location.search + "_" + dataElement.getAttribute("data-ga-label");
        dataElement.setAttribute("data-ga-log", "false");
        if (ga && ga.create) {
            var trackers = ga.getAll();
            if (trackers && trackers.length > 0) {
                var trackerName = trackers[0].get('name');
                ga(trackerName + '.send', 'event', item, event, label);
            }
        }
    } else {
        dataElement.setAttribute("data-ga-log", "true");
    }
}

export function simple_log_event(item: string, event: string, label: string) {
    const ga = (<any>window).ga;
    if (!ga) { return; }

    if (ga && ga.create) {
        var trackers = ga.getAll();
        if (trackers && trackers.length > 0) {
            var trackerName = trackers[0].get('name');
            var eventLabel = window.location.hostname + "_" + label;
            ga(trackerName + '.send', 'event', "USAJOBS_" + item, event, eventLabel);
        }
    }
}

export function log_search(urlObject: any) {
    if (dataLayer !== undefined && dataLayer !== null) {
        let searchTerm = "";

        for (let i = 0; i < SearchTermParams.length; ++i) {
            let param = SearchTermParams[i];
            let value = urlObject[param];

            if (value !== undefined) {
                searchTerm = Array.isArray(value) ? value[0] : value;
                break;
            }
        }

        let dataLayerObject: any = {
            "event": "view_search_results",
            "search_term": searchTerm,
            "location": urlObject['l'] || ''
        };

        for (let key in urlObject) {
            if (key === 'p' || SearchTermParams.indexOf(key) > -1) {
                continue;
            }
            let value = urlObject[key];

            dataLayerObject[`q_${key}`] = Array.isArray(value) ? value[0] : value;
        }
        dataLayer.push(dataLayerObject);
    }
}
